const testConfig = {
  baseUrl: 'https://test-api.dimorder.com',
  mpUrl: 'https://test-mp-order.dimorder.com',
}

export default testConfig
